import React, { useEffect, useState } from 'react';
interface CountdownProps {
  initialHours?: number;
  format?: 'inline' | 'boxes';
}
export function Countdown({
  initialHours = 24,
  format = 'inline'
}: CountdownProps) {
  // Use a fixed initial time for the demo, but in a real app this would be based on a target date
  const [timeLeft, setTimeLeft] = useState(initialHours * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (num: number) => num.toString().padStart(2, '0');
  if (format === 'boxes') {
    return <div className="flex items-center justify-center gap-3" data-id="element-62">
        <div className="flex flex-col items-center" data-id="element-63">
          <div className="bg-navy-900 border border-white/20 rounded-lg w-16 h-16 flex items-center justify-center text-3xl font-bold text-white shadow-inner" data-id="element-64">
            {pad(hours)}
          </div>
          <span className="text-[10px] text-white/60 mt-1 font-bold tracking-wider" data-id="element-65">
            HORAS
          </span>
        </div>
        <span className="text-2xl font-bold text-white/50 pb-5" data-id="element-66">:</span>
        <div className="flex flex-col items-center" data-id="element-67">
          <div className="bg-navy-900 border border-white/20 rounded-lg w-16 h-16 flex items-center justify-center text-3xl font-bold text-white shadow-inner" data-id="element-68">
            {pad(minutes)}
          </div>
          <span className="text-[10px] text-white/60 mt-1 font-bold tracking-wider" data-id="element-69">
            MIN
          </span>
        </div>
        <span className="text-2xl font-bold text-white/50 pb-5" data-id="element-70">:</span>
        <div className="flex flex-col items-center" data-id="element-71">
          <div className="bg-navy-900 border border-white/20 rounded-lg w-16 h-16 flex items-center justify-center text-3xl font-bold text-white shadow-inner" data-id="element-72">
            {pad(seconds)}
          </div>
          <span className="text-[10px] text-white/60 mt-1 font-bold tracking-wider" data-id="element-73">
            SEG
          </span>
        </div>
      </div>;
  }
  return <span className="font-mono font-bold tracking-tight" data-id="element-74">
      {pad(hours)}:{pad(minutes)}:{pad(seconds)}
    </span>;
}